// 1x1 transparent gif
export const DEFAULT_IMAGE_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export const RTE_TOKEN_ATTR = 'rte-token';
